import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ShieldX, ArrowLeft, Home } from 'lucide-react';

const ForbiddenPage = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-[#f8faf8] flex items-center justify-center p-4" data-testid="forbidden-page">
      <div className="text-center">
        <div className="w-24 h-24 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6">
          <ShieldX className="w-12 h-12 text-red-600" />
        </div>
        <h1 className="text-4xl font-bold text-[#2E2E2E] mb-4" data-testid="forbidden-title">{t('portalUi.forbidden.title', 'Nav piekļuves')}</h1>
        <p className="text-[#2E2E2E]/60 mb-2" data-testid="forbidden-description">{t('portalUi.forbidden.description', 'Jums nav tiesību piekļūt šai sadaļai.')}</p>
        <p className="text-[#2E2E2E]/60 mb-8" data-testid="forbidden-detail">{t('portalUi.forbidden.detail', 'Ja uzskātāt, ka tā ir kļūda, sazinieties ar administratoru.')}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button variant="outline" asChild data-testid="forbidden-back-button">
            <Link to="/portal/dashboard">
              <ArrowLeft className="w-4 h-4 mr-2" />
              {t('portalUi.forbidden.backToPanel', 'Atpakaļ uz paneli')}
            </Link>
          </Button>
          <Button className="bg-[#1F3D2B] hover:bg-[#2a5039]" asChild data-testid="forbidden-home-button">
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              {t('portalUi.forbidden.home', 'Galvenā lapa')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenPage;
